<template>
  <ReportPanel>
    <h6 class="q-mt-md">Please select the reporting period for the Te Tumu Waiora Support report.</h6>

    <ReportPeriodSelector
      :period-type="periodType"
      :period-options="periodOptions"
      :month="month"
      :start-date="startDate"
      :end-date="endDate"
      @update:period-type="periodType = $event"
      @update:month="month = $event"
      @update:start-date="startDate = $event"
      @update:end-date="endDate = $event"
    />

    <q-btn
      :loading="loading"
      label="Generate Te Tumu Waiora Support Report"
      color="secondary"
      no-caps
      class="q-mt-md full-width"
      @click="generateReport"
    />
  </ReportPanel>
</template>

<script>
import api from "@/services/api/api";
import notify from "@/services/util/notify";
import { promptDownload } from "@/services/util/file";
import ReportPanel from "./ReportPanel.vue";
import ReportPeriodSelector from "./ReportPeriodSelector.vue";

export default {
  name: "TeTumuWaioraSupportReportPanel",
  components: {
    ReportPanel,
    ReportPeriodSelector
  },
  data() {
    return {
      loading: false,
      periodType: "month",
      periodOptions: [
        { label: "Month", value: "month" },
        { label: "Custom Dates", value: "custom" }
      ],
      month: null,
      startDate: null,
      endDate: null
    }
  },
  methods: {
    async generateReport() {
      this.loading = true;

      try {
        const payload = this.getPayload();
        const report = await api.reports.generateTeTumuWaioraSupport(payload);
        promptDownload(report, this.getFileName());
      } catch (error) {
        console.error(error);
        if (error.isValidationError) {
          notify.error(error.message, "top");
        } else {
          notify.error("There was an issue generating your Te Tumu Waiora Support report.", "top");
        }
      } finally {
        this.loading = false;
      }
    },

    getPayload() {
      if (this.periodType === "month") {
        if (!this.month) {
          const error = new Error("Please select a month");
          error.isValidationError = true;
          throw error;
        }

        return {
          period_type: this.periodType,
          month: this.month
        };
      }

      if (!this.startDate || !this.endDate) {
        const error = new Error("Please select a start date and end date");
        error.isValidationError = true;
        throw error;
      }

      return {
        period_type: this.periodType,
        start_date: this.startDate,
        end_date: this.endDate
      };
    },

    getFileName() {
      if (this.periodType === "month") {
        return `Te Tumu Waiora Support Monthly Report ${this.month}.xlsx`;
      }

      return `Te Tumu Waiora Support Custom Date Report ${this.startDate} to ${this.endDate}.xlsx`;
    }
  }
}
</script>
